export const es = {
  'ad.label': 'Publicidad',
  'ad.sponsored_by': 'Patrocinado por {advertiser}',
  'ad.visit': 'Visitar',
  'cookies.preferences': 'Preferencias de cookies',
  'cookies.title': 'Tu privacidad, bajo tu control',
  'cookies.description': 'Utilizamos almacenamiento necesario para que Albambam funcione. Solo activaremos analítica o marketing si nos das permiso. Puedes retirarlo en cualquier momento. Consulta la',
  'cookies.privacy_link': 'Política de Privacidad',
  'cookies.close': 'Cerrar preferencias',
  'cookies.necessary': 'Necesarias',
  'cookies.necessary_desc': 'Sesión, seguridad, idioma y preferencias básicas.',
  'cookies.analytics': 'Analítica',
  'cookies.analytics_desc': 'Medición anónima de uso para mejorar el servicio.',
  'cookies.marketing': 'Marketing',
  'cookies.marketing_desc': 'Personalización publicitaria y medición de campañas.',
  'cookies.configure': 'Configurar',
  'cookies.reject': 'Rechazar opcionales',
  'cookies.save': 'Guardar selección',
  'cookies.accept': 'Aceptar todas',
  'lang.selector_label': 'Idioma',
  'lang.changed': 'Idioma cambiado',
  'nav.home': 'Inicio',
  'nav.categories': 'Categorías',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Amistad',
  'nav.upload': 'Subir',
  'nav.profile': 'Perfil',
  'nav.login': 'Entrar',
  'common.signed_in': 'Sesión iniciada',
  'common.error': 'Error',
  'topbar.search_placeholder': 'Busca vídeos, creadores...',
  'legal.terms': 'Términos',
  'legal.privacy': 'Privacidad',
  'nav.admin': 'Administración',
  'nav.logout': 'Cerrar sesión',
  'admin.tab.payments': 'Cobros',
  'admin.payments.title': 'Cobros',
  'cats.title': 'Categorías',
  'cats.all': 'Todos',
  'cats.adult_title': 'Categorías +18',
  'cats.empty': 'Ningún vídeo en esta categoría.',
  'friends.block_confirm': '¿Bloquear a este amigo? Ya no podréis chatear ni veros como amigos.',
  'friends.accepted': '¡Ahora sois amigos!',
  'friends.title': 'Amistad',
  'friends.subtitle': 'Solo quienes se siguen mutuamente se convierten en amigos y pueden chatear en privado.',
  'friends.unread_count_label': '{n} mensajes por leer',
  'friends.blocked_users_title': 'Usuarios bloqueados',
  'friends.unblock_user': 'Desbloquear',
  'friends.requests_title': 'Solicitudes de chat',
  'friends.request_badge': 'Solicitud',
  'friends.request_accept': 'Aceptar',
  'friends.request_ignore': 'Ignorar',
  'friends.empty_title': 'Aún no tienes amigos',
  'friends.empty_subtitle': 'Sigue a alguien y que te siga de vuelta para desbloquear el chat privado.',
  'friends.attach_image': 'Foto',
  'friends.shared_video_label': 'Ha compartido un vídeo',
  'friends.select_conversation': 'Selecciona un amigo para empezar a chatear',
  'friends.block_user': 'Bloquear',
  'friends.no_messages_yet': 'Aún no hay mensajes. ¡Saluda!',
  'friends.message_placeholder': 'Escribe un mensaje...',
  'section.trending': 'Tendencias',
  'section.shorts': 'Shorts',
  'section.for_you': 'Para ti',
  'home.hero.badge': 'Bienvenido a Albambam',
  'home.hero.title_1': 'Vídeos cortos.',
  'home.hero.title_2': 'Creadores reales.',
  'home.hero.subtitle': 'Mira, comparte y gana. Sube tus vídeos y descubre nuevos talentos en cada categoría.',
  'home.hero.cta_shorts': 'Ver Shorts',
  'home.hero.cta_trending': 'Tendencias',
  'home.shorts.see_all': 'Ver todos',
  'home.empty.title': 'Aún no hay vídeos',
  'home.empty.subtitle': 'Cuando los creadores suban contenido, aparecerá aquí.',
  'live.send_diamonds': 'Enviar diamantes',
  'live.buy': 'Comprar',
  'live.chat': 'Chat',
  'live.type_message': 'Escribe un mensaje...',
  'live.send': 'Enviar',
  'auth.success_google': 'Sesión iniciada con Google',
  'auth.fail_google': 'Sesión de Google no válida',
  'auth.success_login': 'Sesión iniciada',
  'auth.success_register': 'Cuenta creada',
  'auth.login_tab': 'Entrar',
  'auth.register_tab': 'Crear cuenta',
  'auth.email': 'Correo electrónico',
  'auth.password': 'Contraseña',
  'auth.submit_login_loading': 'Entrando...',
  'auth.submit_login': 'Entrar',
  'auth.name': 'Nombre',
  'auth.submit_register_loading': 'Creando...',
  'auth.submit_register': 'Crear cuenta',
  'auth.or': 'o',
  'legal.privacy_title': 'Política de Privacidad',
  'search.title': 'Resultados para “{q}”',
  'search.count': '{n} vídeos',
  'search.empty': 'Sin resultados.',
  'series.load_error': 'No se ha podido cargar la serie',
  'series.unlocked': 'Serie desbloqueada',
  'series.purchase_error': 'No se ha podido iniciar la compra',
  'series.restricted': 'Acceso restringido',
  'series.configure_access': 'Configurar acceso',
  'series.language_all': 'Todos los idiomas',
  'series.episode_count': '{n} episodios',
  'series.buy': 'Comprar serie',
  'series.filter_language': 'Filtrar por idioma',
  'series.no_episodes': 'Todavía no hay episodios publicados.',
  'series.episode_number': 'Episodio {n}',
  'legal.terms_title': 'Términos y Condiciones',
  'lang.ca': 'Catalán',
  'lang.en': 'Inglés',
  'lang.es': 'Castellano',
  'lang.fr': 'Francés',
  'lang.de': 'Alemán',
  'lang.it': 'Italiano',
  'lang.eu': 'Euskera',
  'lang.gl': 'Gallego',
  'lang.zh': 'Chino',
  'lang.other': 'Otros',
  'lang.vi': 'Vietnamita',
  'lang.ja': 'Japonés',
  'lang.ko': 'Coreano',
  'lang.ru': 'Ruso',
  'lang.ro': 'Rumano',
  'lang.ar': 'Árabe',
  'lang.tr': 'Turco',
  'lang.pl': 'Polaco',
  'lang.ms': 'Malayo',
  'lang.ta': 'Tamil',
  'upload.series_title_error': 'Escribe el título de la serie',
  'upload.series_adult_category_error': 'Selecciona una categoría +18 para la serie',
  'upload.series_created': 'Serie creada',
  'upload.series_create_error': 'No se ha podido crear la serie',
  'upload.err_file': 'Selecciona un archivo de vídeo válido',
  'upload.err_title': 'Pon un título',
  'upload.series_select_error': 'Selecciona o crea una serie',
  'upload.trailer_target_error': 'Selecciona el vídeo o serie del tráiler',
  'upload.price_error': 'Introduce un precio válido de al menos 0,50 EUR.',
  'upload.adult_category_error': 'Selecciona una categoría adulta',
  'upload.success': 'Vídeo subido correctamente',
  'upload.title_h': 'Sube un vídeo',
  'upload.kind': 'Tipo de publicación',
  'upload.kind_video': 'Vídeo independiente',
  'upload.kind_episode': 'Episodio de una serie',
  'upload.kind_trailer': 'Tráiler público en Shorts',
  'upload.series': 'Serie',
  'upload.series_select': 'Selecciona una serie',
  'upload.episode': 'Episodio',
  'upload.series_new_title': 'Título de una serie nueva',
  'upload.series_create': 'Crear serie',
  'upload.series_adult': 'Serie +18',
  'upload.series_premium': 'Serie premium',
  'upload.series_adult_category': 'Categoría +18 de la serie',
  'upload.series_price': 'Precio por episodio y paquete (EUR)',
  'upload.trailer_for': 'El tráiler presenta',
  'upload.trailer_select': 'Selecciona vídeo o serie',
  'upload.video_prefix': 'Vídeo',
  'upload.file_label': 'Archivo de vídeo (MP4, máx 1GB)',
  'upload.file_pick': 'Haz clic para seleccionar un vídeo',
  'upload.thumb_label': 'Miniatura (opcional)',
  'upload.video_title': 'Título',
  'upload.description': 'Descripción',
  'upload.category': 'Categoría',
  'upload.is_short': 'Es un Short (vertical)',
  'upload.paid_video': 'Vídeo de pago',
  'upload.adult_content': 'Contenido +18',
  'upload.video_language': 'Idioma del vídeo',
  'upload.individual_price': 'Precio para ver este vídeo (EUR)',
  'upload.paid_video_help': 'El espectador compra acceso permanente solo a este vídeo. El precio mínimo es 0,50 EUR.',
  'upload.adult_category': 'Categoría adulta',
  'upload.uploading': 'Subiendo {n}%',
  'upload.submit': 'Subir vídeo',
  'user.followers': 'seguidores',
  'user.following': 'seguidos',
  'user.follow': 'Seguir',
  'user.chat_open': 'Chatear',
  'user.request_sent': 'Solicitud enviada',
  'user.send_message': 'Enviar mensaje',
  'user.followers_title': 'Seguidores',
  'user.following_title': 'Seguidos',
  'user.unfollow': 'Dejar de seguir',
  'user.request_title': 'Solicitud de chat',
  'user.request_subtitle': 'Solo puedes enviar un mensaje. Si acepta la solicitud, seréis amigos y podréis chatear.',
  'user.request_placeholder': 'Escribe tu mensaje...',
  'user.request_send': 'Enviar solicitud',
  'shorts.login_for_like': 'Inicia sesión para dar Me gusta',
  'watch.share_copied': 'Enlace copiado',
  'watch.delete_confirm': '¿Eliminar este comentario?',
  'ad.skip_in': 'Saltar en {n}s',
  'ad.skip': 'Saltar anuncio',
  'watch.share': 'Compartir',
  'friends.share_video': 'Compartir un vídeo',
  'friends.send': 'Enviar',
  'watch.comments': 'Comentarios',
  'watch.write_comment': 'Escribe un comentario...',
  'watch.publish': 'Publicar',
  'watch.login_to_comment': 'Inicia sesión para comentar.',
  'watch.login_btn': 'Entra para comentar',
  'watch.no_comments': 'Todavía no hay comentarios.',
  'watch.related': 'Relacionados',
  'nav.trending': 'Tendencias',
  'friends.follow_option_only_follow': 'Seguir',
  'friends.follow_option_friends': 'Amigos',
  'watch.like': 'Me gusta',
  'watch.views_short': '{n} visualizaciones',
  'shorts.empty.title': 'Aún no hay Shorts',
  'shorts.empty.subtitle': 'Sube un vídeo corto para estrenar la sección.',
  'shorts.share': 'Compartir',
  'auth.continue_google': 'Continúa con Google',
  'upload.is_premium': 'Premium',
  'upload.price': 'Precio (€)',
  'upload.err_select': 'Selecciona un vídeo',
  'profile.upload_btn': 'Subir vídeo',
  'profile.tab_videos': 'Mis vídeos ({n})',
  'profile.tab_history': 'Historial',
  'profile.tab_recos': 'Recomendaciones',
  'profile.no_videos': 'Aún no has subido ningún vídeo.',
  'profile.no_history': 'Aún no has visto ningún vídeo.',
  'profile.no_recos': 'Mira algunos vídeos para recibir recomendaciones.',
  'profile.likes': 'me gusta',
  'profile.views': 'visualizaciones',
  'wallet.title': 'Cartera',
  'wallet.rate_label': 'Tasa',
  'wallet.min_label': 'Mín. retirada',
  'wallet.amount_label': 'Cantidad a retirar',
  'wallet.withdraw_btn': 'Solicitar retirada',
  'wallet.history_title': 'Historial de solicitudes',
  'wallet.success': 'Solicitud creada',
  'wallet.bad_amount': 'Cantidad no válida',
  'wallet.per_view': '{rate} {cur}/visualización',
  'admin.title': 'Administración',
  'admin.stats.users': 'Usuarios',
  'admin.stats.videos': 'Vídeos',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Visualizaciones',
  'admin.tab.videos': 'Vídeos',
  'admin.tab.ads': 'Anuncios',
  'admin.tab.users': 'Usuarios',
  'admin.tab.withdrawals': 'Retiradas',
  'admin.tab.config': 'Configuración',
  'admin.tab.translations': 'Idiomas',
  'tbl.title': 'Título',
  'tbl.creator': 'Creador',
  'tbl.category': 'Categoría',
  'tbl.type': 'Tipo',
  'tbl.views': 'Views',
  'tbl.likes': 'Likes',
  'tbl.status': 'Estado',
  'tbl.actions': 'Acciones',
  'tbl.placement': 'Posición',
  'tbl.advertiser': 'Anunciante',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Clicks',
  'tbl.active': 'Activo',
  'tbl.name': 'Nombre',
  'tbl.email': 'Correo',
  'tbl.role': 'Rol',
  'tbl.wallet': 'Cartera',
  'tbl.amount': 'Cantidad',
  'tbl.date': 'Fecha',
  'tbl.user': 'Usuario',
  'video.video': 'Vídeo',
  'video.short': 'Short',
  'action.show': 'Publicar',
  'action.hide': 'Ocultar',
  'action.delete_confirm_video': '¿Eliminar vídeo?',
  'ad.create_h': 'Crear anuncio',
  'ad.title_label': 'Título',
  'ad.image_label': 'URL imagen',
  'ad.target_label': 'URL destino',
  'ad.advertiser_label': 'Anunciante',
  'ad.placement_label': 'Ubicación',
  'ad.placement.banner': 'Banner (sitio web)',
  'ad.placement.preroll': 'Pre-roll (antes del vídeo)',
  'ad.placement.overlay': 'Overlay (dentro del vídeo)',
  'ad.active': 'Activo',
  'ad.create_btn': 'Crear',
  'ad.success_create': 'Anuncio creado',
  'ad.delete_confirm': '¿Eliminar anuncio?',
  'users.make_admin': 'Hacer admin',
  'users.remove_admin': 'Quitar admin',
  'wd.approve': 'Aprobar',
  'wd.reject': 'Rechazar',
  'wd.mark_paid': 'Marcar pagado',
  'wd.empty': 'Sin solicitudes',
  'cfg.title': 'Configuración de pagos',
  'cfg.rate_label': 'Pago por visualización ({cur})',
  'cfg.min_label': 'Mínimo para retirar ({cur})',
  'cfg.currency': 'Moneda',
  'cfg.save': 'Guardar',
  'cfg.saved': 'Configuración guardada',
  'trans.title': 'Idiomas y traducciones',
  'trans.intro': 'Sube un archivo JSON con traducciones para cualquier código de idioma (p.ej. ja, pt, zh). El archivo debe contener un mapeo plano de clave → texto.',
  'trans.code_label': 'Código de idioma (p.ej. ja, pt-BR, zh)',
  'trans.name_label': 'Nombre (en ese idioma)',
  'trans.file_label': 'Archivo JSON de traducciones',
  'trans.upload': 'Subir',
  'trans.uploaded': 'Traducciones guardadas',
  'trans.delete': 'Eliminar',
  'trans.delete_confirm': '¿Eliminar este idioma?',
  'trans.builtin': 'Integrado',
  'trans.custom': 'Personalizado',
  'trans.empty_custom': 'Aún no hay idiomas personalizados.',
  'common.cancel': 'Cancelar',
  'common.loading': 'Cargando...',
  'common.too_fast': 'Demasiado rápido, espera un momento',
  'time.few_seconds': 'hace unos segundos',
  'time.min': 'hace {n} min',
  'time.h': 'hace {n} h',
  'time.d': 'hace {n} d',
  'time.w': 'hace {n} sem',
  'time.mo': 'hace {n} mes',
  'time.y': 'hace {n} año',
  'brand.tagline': 'Vídeos cortos. Creadores reales.',
  'live.section': 'En directo',
  'live.start': 'Iniciar directo',
  'live.end': 'Finalizar directo',
  'live.join': 'Entrar en directo',
  'live.chat_placeholder': 'Escribe un mensaje...',
  'live.diamond': 'Diamante',
  'live.buy_access': 'Comprar acceso',
  'live.save_recording': 'Guardar grabación',
};
